(function () {
  'use strict';
  if (document.documentElement.lang !== 'ar') return;
  var labels = window.BBArabicUI || {};
  var digits = '٠١٢٣٤٥٦٧٨٩';
  var quantityInputs = new WeakSet();
  function numberText(value) {
    return value.replace(/[0-9]/g, function (digit) { return digits[digit]; });
  }
  function text(node) {
    var parent = node.parentElement;
    if (!parent || parent.closest('script, style, pre, code, textarea, input, [contenteditable], a[href^="tel:"], a[href^="mailto:"], .xb-pq em, [ref="cartItemCount"]')) return;
    var value = node.nodeValue;
    if (parent.closest('#rapid_reviews_items')) {
      if (labels.widget && labels.widget[value.trim()]) value = value.replace(value.trim(), labels.widget[value.trim()]);
      if (parent.closest('.r_name')) value = value.replace(/^by\s+/, (labels.by || '') + ' ');
      if (parent.closest('.r_date')) {
        var age = value.match(/^\s*(\d+)\s+(day|week|month|year|hour|minute)s?\s+ago\s*$/);
        if (age) value = new Intl.RelativeTimeFormat('ar-u-nu-arab', {numeric: 'auto'}).format(-Number(age[1]), age[2]) + ' ';
      }
      var translations = {
        'Write A Review': labels.review_write,
        'write a review': labels.review_write,
        'Ask A Question': labels.question_ask,
        'Be the first to': parent.closest('[data-type="q"]') ? labels.no_questions : labels.no_reviews,
        'Reviews': labels.reviews,
        'Questions': labels.questions
      };
      Object.keys(translations).forEach(function (english) {
        if (translations[english]) value = value.split(english).join(translations[english]);
      });
    }
    if (/[0-9]/.test(value) && !/[A-Za-z]/.test(value)) value = numberText(value);
    if (value !== node.nodeValue) node.nodeValue = value;
  }
  function money(svg) {
    if (svg.closest('.bb-money-run')) return;
    var currency = svg.closest('.cur') || svg;
    var amount = currency.nextSibling;
    while (amount && amount.nodeType === 3 && !amount.nodeValue.trim()) amount = amount.nextSibling;
    if (!amount) return;
    var value = amount.textContent;
    if (amount.nodeType === 1 && !/^[\s0-9٠-٩.,٬٫]+$/.test(value)) return;
    if (amount.nodeType === 3) {
      var match = value.match(/^\s*[0-9٠-٩][0-9٠-٩.,٬٫]*/);
      if (!match) return;
      if (match[0].length < value.length) amount.splitText(match[0].length);
    }
    var run = document.createElement('bdi');
    run.className = 'bb-money-run';
    run.dir = 'ltr';
    currency.parentNode.insertBefore(run, currency);
    run.appendChild(currency);
    run.appendChild(amount);
  }
  function quantity(input) {
    if (!input) return;
    var parent = input.closest('.quantity-selector');
    if (!parent) return;
    var display = parent.querySelector('.bb-arabic-quantity-value');
    if (!display) {
      display = document.createElement('span');
      display.className = 'bb-arabic-quantity-value';
      display.setAttribute('aria-hidden', 'true');
      input.insertAdjacentElement('afterend', display);
    }
    parent.classList.add('bb-arabic-quantity');
    if (!quantityInputs.has(input)) {
      quantityInputs.add(input);
      parent.addEventListener('quantity-selector:update', function () { quantity(input); });
      input.addEventListener('input', function () { quantity(input); });
      input.addEventListener('blur', function () { requestAnimationFrame(function () { quantity(input); }); });
    }
    var value = numberText(input.value);
    if (display.textContent !== value) display.textContent = value;
    if (input.getAttribute('aria-valuetext') !== value) input.setAttribute('aria-valuetext', value);
  }
  function element(el) {
    if (el.nodeType !== 1 || el.closest('script,style,pre,code')) return;
    ['aria-label', 'title', 'alt'].forEach(function (attribute) {
      var value = el.getAttribute(attribute);
      if (value && el.closest('#rapid_reviews_items') && labels.widget) {
        if (labels.widget[value.trim()]) value = labels.widget[value.trim()];
        else if (/^Liked\s*[0-9]*$/.test(value)) value = labels.widget.Liked + value.replace('Liked', '');
        else if (/^\d+ star reviews are \d+%$/.test(value)) {
          var tier = value.match(/^(\d+) star reviews are (\d+)%$/);
          value = labels.reviews + ': ' + tier[1] + ' / 5، ' + tier[2] + '%';
        }
      }
      if (value && /[0-9]/.test(value) && !/[A-Za-z]/.test(value)) el.setAttribute(attribute, numberText(value));
      else if (value && value !== el.getAttribute(attribute)) el.setAttribute(attribute, value);
    });
    if (el.matches('#rapid_reviews_items input[placeholder="Search..."]')) el.setAttribute('placeholder', labels.widget['Search...']);
    if (el.matches('main .g-img, main .product-media__image, main .slideshow-controls__thumbnail img, main .sticky-add-to-cart__image-img, [data-b2b-main] img, [data-b2b-thumbs] img, [data-xp-main] img, [data-xp-thumbs] img')) {
      if (/[A-Za-z]/.test(el.alt) && labels.product_title) el.alt = numberText(labels.product_title + ' — ' + labels.photo);
    }
    if (el.matches('main article a[href*="/products/"] img') && /[A-Za-z]/.test(el.alt)) {
      var heading = el.closest('article').querySelector('h2, h3');
      if (heading && /[\u0600-\u06ff]/.test(heading.textContent)) el.alt = numberText(heading.textContent.trim() + ' — ' + labels.photo);
    }
    if (el.matches('svg[aria-label="درهم"]')) money(el);
    if (el.matches('.quantity-selector input[type="number"]')) quantity(el);
  }
  function scan(root) {
    if (root.nodeType === 3) { text(root); return; }
    if (root.nodeType !== 1) return;
    element(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) text(node);
    root.querySelectorAll('[aria-label], [title], img').forEach(element);
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'characterData') text(change.target);
        else if (change.type === 'attributes') element(change.target);
        else {
          change.addedNodes.forEach(scan);
          if (change.removedNodes.length && change.target.nodeType === 1) {
            var selector = change.target.closest('.quantity-selector');
            if (selector) quantity(selector.querySelector('input[type="number"]'));
          }
        }
      });
    }).observe(document.body, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'alt']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
